import styled from "styled-components"

export interface IconWrapperProps {
  size: number
}
export const IconWrapper = styled.span<IconWrapperProps>`
  ${({size}) => size && `height: ${size}px;`};
  vertical-align: text-top;
  display: inline-flex;
  justify-content: center;
  align-items: center;
`
